import { createSelector } from 'reselect';

export default {
  getMessages: createSelector(
    (state) => state.aiChat.messages,
    (messages) => messages
  ),

  getIsLoading: createSelector(
    (state) => state.aiChat.isLoading,
    (isLoading) => isLoading
  ),

  getHasError: createSelector(
    (state) => state.aiChat.hasError,
    (hasError) => hasError
  ),

  getErrorMessage: createSelector(
    (state) => state.aiChat.errorMessage,
    (errorMessage) => errorMessage
  ),

  getIsVisible: createSelector(
    (state) => state.aiChat.isVisible,
    (isVisible) => isVisible
  ),

  getHasUnreadDailyMessage: createSelector(
    (state) => state.aiChat.hasUnreadDailyMessage,
    (hasUnreadDailyMessage) => hasUnreadDailyMessage
  ),

  getLastDailyCheckDate: createSelector(
    (state) => state.aiChat.lastDailyCheckDate,
    (lastDailyCheckDate) => lastDailyCheckDate
  ),
};
